const DataBase = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-DataBase"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-DataBase"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M8.5,22c-4.206,0-6.5-1.463-6.5-2.214v-2.327c1.535,.954,3.835,1.541,6.5,1.541,.216,0,.426-.01,.637-.018-.085-.482-.137-.976-.137-1.482,0-.173,.016-.342,.026-.512-.173,.006-.346,.012-.526,.012-3.968,0-6.5-1.48-6.5-2.5v-2.041c1.535,.954,3.835,1.541,6.5,1.541,.441,0,.867-.022,1.286-.053,.376-.816,.877-1.56,1.48-2.211-.814,.164-1.741,.264-2.766,.264-3.968,0-6.5-1.48-6.5-2.5v-2.041c1.535,.954,3.835,1.541,6.5,1.541s4.965-.588,6.5-1.541v1.916c.637-.196,1.309-.309,2-.35V4.5C17,1.935,13.346,0,8.5,0S0,1.935,0,4.5v15.286c0,2.767,4.276,4.214,8.5,4.214,1.092,0,2.185-.099,3.209-.29-.57-.531-1.064-1.139-1.471-1.808-.541,.058-1.111,.098-1.739,.098Zm0-20c3.968,0,6.5,1.48,6.5,2.5s-2.532,2.5-6.5,2.5-6.5-1.48-6.5-2.5,2.532-2.5,6.5-2.5Zm9,9c-3.59,0-6.5,2.91-6.5,6.5s2.91,6.5,6.5,6.5,6.5-2.91,6.5-6.5-2.91-6.5-6.5-6.5Zm2.5,9h-5.5c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5c.009,0,.017,.002,.025,.003-.008-.084-.025-.166-.025-.253,0-1.519,1.231-2.75,2.75-2.75,1.261,0,2.313,.854,2.637,2.011,.038-.002,.074-.011,.113-.011,1.105,0,2,.895,2,2s-.895,2-2,2Z" />
    </svg>
  );
};

export default DataBase;
